// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./app/widgets/management/group-manage/app/css/app.css
// module id = 771
// module chunks = 0